import { EMAIL_REGEX } from "src/utils";

/**
 * The shared EMAIL_REGEX is unanchored, so on its own it matches an address
 * sitting inside a line of prose. Staging a user is a create, and a typo here
 * reaches Keycloak, so the whole field has to be the address.
 */
const isAddress = (email) => {
    const trimmed = (email || "").trim();
    const match = trimmed.match(EMAIL_REGEX);
    return !!match && match[0] === trimmed;
};

/** The domains a counterparty accepts, from its comma-separated config. */
export const parseMailDomains = (mailDomains) =>
    (mailDomains || "")
        .split(",")
        .map((d) => d.trim().toLowerCase())
        .filter(Boolean);

/**
 * The address a new user is being created with, or a message saying why it
 * cannot be. `mailDomains` is the counterparty's configured list; pass null for
 * a platform account, which belongs to no counterparty and so has no list.
 *
 * Mirrors SetupCptyController.validateEmailDomain, which rejects the same
 * addresses with a 4xx. Checking here means the operator is told at the point
 * of typing rather than after confirming a batch.
 */
export const validateNewUserEmail = (email, mailDomains) => {
    const trimmed = (email || "").trim();
    if (!trimmed) return "Email is required";
    if (!isAddress(trimmed)) return "Enter a valid email address";
    if (mailDomains === null || mailDomains === undefined) return null;

    const allowed = parseMailDomains(mailDomains);
    if (allowed.length === 0) {
        return "Signup is not configured for this counterparty";
    }
    const domain = trimmed.slice(trimmed.lastIndexOf("@") + 1).toLowerCase();
    if (!allowed.includes(domain)) {
        return `Email domain '${domain}' is not allowed for this counterparty. Allowed: ${allowed.join(", ")}`;
    }
    return null;
};
